import { useState } from 'react';
import { Button } from 'react-bootstrap';

import {
    TaskslistTable,
    Pagination,
    FilterOffcanvas,
    AddModal,
    ViewHistoryOffcanvas,
    DeleteTaskModal,
    ContactDetailsModal
} from './components';

const MyTasklist = () => {
    // Modal States
    const [show, setShow] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showHistory, setShowHistory] = useState(false);

    // Pagination States
    const [pageSize, setPageSize] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const totalItems = 100; // This would come from your API
    const totalPages = Math.ceil(totalItems / pageSize);

    // Filter States
    const [showFilter, setShowFilter] = useState(false);
    const [projectFilter, setProjectFilter] = useState(null);
    const [taskListFilter, setTaskListFilter] = useState(null);
    const [assigneeFilter, setAssigneeFilter] = useState(null);
    const [stageFilter, setStageFilter] = useState(null);

    // History States
    const [historyTab, setHistoryTab] = useState('all'); // 'all' | 'comments' | 'updates'
    const [historyList] = useState([]); // Will be populated from API

    // Contact Modal States
    const [showContact, setShowContact] = useState(false);
    const [selectedContact, setSelectedContact] = useState(null);

    // Form States
    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedTaskList, setSelectedTaskList] = useState('');
    const [selectedWorkflow, setSelectedWorkflow] = useState(null);
    const [selectedAssignees, setSelectedAssignees] = useState([]);

    // Options
    const projectOptions = [
        { value: 'project1', label: 'Project 1' },
        { value: 'project2', label: 'Project 2' },
        { value: 'project3', label: 'Project 3' }
    ];

    const workflowOptions = [
        { value: 'workflow1', label: 'Workflow 1' },
        { value: 'workflow2', label: 'Workflow 2' },
        { value: 'workflow3', label: 'Workflow 3' }
    ];

    const assigneeOptions = [
        { value: 'user1', label: 'User 1' },
        { value: 'user2', label: 'User 2' },
        { value: 'user3', label: 'User 3' }
    ];

    const stageOptions = [
        { value: 'todo', label: 'To Do' },
        { value: 'inProgress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' }
    ];

    // Handler Functions
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleDeleteShow = () => setShowDelete(true);
    const handleDeleteClose = () => setShowDelete(false);
    const handleDelete = () => {
        // TODO: Implement delete functionality
        console.log('Deleting tasklist');
        handleDeleteClose();
    };

    const handleHistoryShow = () => setShowHistory(true);
    const handleHistoryClose = () => setShowHistory(false);

    const handleContactClose = () => {
        setShowContact(false);
        setSelectedContact(null);
    };

    return (
        <>
            <div className='c-card-1'>
                <div className='c-card-header-1'>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div>
                            Tasklists
                        </div>
                        <div className='d-flex align-items-center gap-1'>
                            <Button 
                                variant='outline-primary' 
                                className='btn-sm me-2 text-nowrap'
                                onClick={() => setShowFilter(true)}
                            >
                                <i className="fas fa-filter me-1"></i>
                                Filter
                            </Button>
                            <Button 
                                variant='primary'
                                className='btn-sm text-nowrap'
                                onClick={handleShow}
                            >
                                <i className="fas fa-plus me-1"></i>
                                Add Tasklist
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='c-card-body-1 p-0'>
                    <TaskslistTable
                        onEdit={handleShow}
                        onDelete={handleDeleteShow}
                        onViewHistory={handleHistoryShow}
                        onContactClick={(contact) => {
                            setSelectedContact(contact);
                            setShowContact(true);
                        }}
                    />
                </div>
                <div className='c-card-footer-1'>
                    <Pagination
                        pageSize={pageSize}
                        onPageSizeChange={setPageSize}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                    />
                </div>
            </div>

            <AddModal
                show={show}
                onHide={handleClose}
                selectedProject={selectedProject}
                setSelectedProject={setSelectedProject}
                selectedTaskList={selectedTaskList}
                setSelectedTaskList={setSelectedTaskList}
                selectedWorkflow={selectedWorkflow}
                setSelectedWorkflow={setSelectedWorkflow}
                selectedAssignees={selectedAssignees}
                setSelectedAssignees={setSelectedAssignees}
                projectOptions={projectOptions}
                workflowOptions={workflowOptions}
                assigneeOptions={assigneeOptions}
            />

            <FilterOffcanvas
                show={showFilter}
                onHide={() => setShowFilter(false)}
                projectFilter={projectFilter}
                setProjectFilter={setProjectFilter}
                taskListFilter={taskListFilter}
                setTaskListFilter={setTaskListFilter}
                assigneeFilter={assigneeFilter}
                setAssigneeFilter={setAssigneeFilter}
                stageFilter={stageFilter}
                setStageFilter={setStageFilter}
                projectOptions={projectOptions}
                assigneeOptions={assigneeOptions}
                stageOptions={stageOptions}
            />

            <DeleteTaskModal
                show={showDelete}
                onHide={handleDeleteClose}
                onConfirm={handleDelete}
            />

            <ViewHistoryOffcanvas
                show={showHistory}
                onHide={handleHistoryClose}
                historyTab={historyTab}
                setHistoryTab={setHistoryTab}
                historyList={historyList}
            />

            <ContactDetailsModal
                show={showContact}
                onHide={handleContactClose}
                contact={selectedContact}
            />
        </>
    );
};

export default MyTasklist;